import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import es from "./locales/es.json";
import en from "./locales/en.json";

const SUPPORTED = ["es", "en"];
const DEFAULT_LANG = "es";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { es: { translation: es }, en: { translation: en } },
    fallbackLng: DEFAULT_LANG,
    supportedLngs: SUPPORTED,
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "sprintroll-lang",
      caches: ["localStorage"],
    },
    returnEmptyString: false,
  });

// Normalize regional codes (es-MX → es, en-US → en)
if (i18n.language && !SUPPORTED.includes(i18n.language)) {
  const base = i18n.language.split("-")[0];
  i18n.changeLanguage(SUPPORTED.includes(base) ? base : DEFAULT_LANG);
}

export default i18n;
export { SUPPORTED, DEFAULT_LANG };
